import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {fetchReporting, resetReporting, updateReporting} from "../../../creators/reporting";
import createLink from "../../../libs/createLink";
import {PageLoader, LoadingBar} from "../../components/Loader";
import {Button, ButtonGroup} from "../../components/Button";
import DateSince from "../../components/Date";
import DraftContentReader from "../../components/editor/DraftContentReader";
import ReportingComments from "./ReportingComments";
import _ from "lodash";


class Reporting extends React.Component {
    constructor(props) {
        super(props);
        this.currentId = this.props.match.params.reportId || false;
        this.statusList = [{_id : 0, title : "Nouveaux"}, {_id : 1, title : "En cours"}, {_id : 2, title : "Résolus"}];
        this.state = {
            status : 0,
            toogleSubject : false
        };
        this.linkContent = '';
        this.props.resetReporting();
        if(this.currentId){
            this.props.fetchReporting(this.currentId);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reportingInitialized !== this.props.reportingInitialized) {
            this.setState({status: this.props.reporting.status || 0});
            let content = this.props.reporting.content || {};
            let owner = content.owner || {};
            switch (this.props.reporting.kind) {
                case"media":
                    if(content === "video"){
                        this.linkContent = <a href={createLink("mediaviewerPhoto", {...owner, media : content})} target={"_new"}>{content.title}</a>
                    }
                    else{
                        this.linkContent = <a href={createLink("mediaviewerVideo", {...owner, media : content})} target={"_new"}>{content.title}</a>
                    }
                    break;
                case"album":
                    this.linkContent = <a href={createLink("userAlbum", {...content.owner, album : content})} target={"_new"}>{content.title}</a>
                    break;
                case"status":
                    this.linkContent = <a href={createLink("userProfile", {...content.owner})} target={"_new"}>Voir le profile</a>
                    break;
                case"user":
                    this.linkContent = <a href={createLink("userProfile", {...content})} target={"_new"}>Voir le profile</a>
                    break;
                case"article":
                    this.linkContent = <a href={createLink("article", {...owner, article : content})} target={"_new"}>{content.title}</a>
                    break;
                case"topic":
                    let topic = this.props.reporting.topic;
                    owner = topic.owner || {};
                    this.linkContent = <a href={createLink("forumTopic", {...owner, topic : topic, category : topic.forum})} target={"_new"}>{topic.title}</a>
                    break;
                case"comment":
                    if(content.parentKind === "media"){
                        let media = this.props.reporting.media;
                        owner = media.owner || {};
                        if(this.props.reporting.media.kind === "video"){
                            this.linkContent = <a href={createLink("mediaviewerPhoto", {...owner, media : media})} target={"_new"}>{media.title}</a>
                        }
                        else{
                            this.linkContent = <a href={createLink("mediaviewerVideo", {...owner, media : media})} target={"_new"}>{media.title}</a>
                        }
                    }
                    else if(content.parentKind === "article"){
                        let article = this.props.reporting.article;
                        owner = article.owner || {};
                        this.linkContent = <a href={createLink("article", {...owner, article : article})} target={"_new"}>{article.title}</a>
                    }
                    else{
                        this.linkContent = content.title;
                    }
                    break;
                case"topicComment":
                    let topicComment = this.props.reporting.topic;
                    owner = topicComment.owner || {};
                    if(this.props.reporting.currentPage){
                        topicComment = {
                            ...topicComment,
                            page : this.props.reporting.currentPage,
                            ancre : `#${content._id}`
                        }
                    }
                    this.linkContent = <a href={createLink("forumTopic", {...owner, topic : topicComment, category : topicComment.forum})} target={"_new"}>{topicComment.title}</a>
                    break;
                default:
                    this.linkContent = "";
            }

        }
    }

    handleStatus(status) {
        if (!this.props.reportingLoading) {
            this.setState({status})
            this.props.updateReporting(this.props.reporting._id, {status});
        }
    }

    render() {
        console.log(this.props.reporting);
        return !this.props.reportingInitialized ? (<PageLoader />) : (
            <div id="reporting">
                <div className={"mb-16"}>
                    <div className={"form-status"}>
                        <div className={"status"}>
                            <label>Changer le statut</label>
                            <ButtonGroup>
                                {this.statusList.map((item, index) => (
                                    <Button key={`status_${index}`}
                                            active={this.state.status === item._id ? 'active no-cursor' : ''}
                                            onClick={() => this.state.status !== item._id ? this.handleStatus(item._id) : 0} content={item.title}/>
                                ))}
                            </ButtonGroup>
                        </div>
                        <div>
                            <Button onClick={() => this.props.history.push(createLink("pcModerator"))}
                                    btnStyle={"primary-reverse"}
                                    className={"right"}
                                    size={"small"}
                                    content={"Retour aux rapports"}/>
                        </div>
                    </div>
                    {this.props.reportingLoading && <LoadingBar />}
                </div>
                <div className={"mb-16"}>
                    Accés au contenu reporté : {this.linkContent}
                </div>
                <div className={"mb-16"}>
                    {_.get(this.props,"reporting.content._id") ? <a href={`${createLink("pcModerator")}?content=${this.props.reporting.content._id}`} target={"_new"}>Voir tous les rapports de ce contenu </a> : null}
                </div>
                <div className={"mb-16"}>
                    {_.get(this.props,"reporting.owner._id") ? <a href={`${createLink("pcModerator")}?owner=${this.props.reporting.owner._id}`} target={"_new"}>Voir tous les rapports de ce membre </a> : null}
                </div>
                <div className={"subject"}>
                    <div className={"avatar"}>
                        {_.get(this.props,"reporting.owner.profile.avatar") && (<img src={`${this.props.reporting.owner.profile.avatar}?width=80&height=80`} alt={"avatar"} />)}
                    </div>
                    <div className={"content"}>
                            <div className={"content-header flex-jc-sb"}>
                                <div >
                                    {_.get(this.props,"reporting.owner._id") ? <a href={createLink("userProfile", this.props.reporting.owner)} target={"new"}>{this.props.reporting.owner && this.props.reporting.owner.username}</a> : null}
                                </div>
                                <div className={"text-right"} >
                                    <DateSince date={this.props.reporting.createdAt} />
                                </div>
                            </div>
                            <div className={"content-body"}>
                                <span className={"message-report"}>Message du rapport :</span> {this.props.reporting.message}

                                {_.get(this.props,"reporting.content._id") ? (
                                    <Fragment>
                                        {(this.props.reporting.kind === "article" || this.props.reporting.kind === "topic" || this.props.reporting.kind === "status" || this.props.reporting.kind === "comment" || this.props.reporting.kind === "topicComment" || this.props.reporting.kind === "album" || this.props.reporting.kind === "roomMessage" || this.props.reporting.kind === "media") && (
                                            <span className={"message-subject"} onClick={() => this.setState({toogleSubject : !this.state.toogleSubject})}> {this.state.toogleSubject ? "Cacher" : "Voir"} le message du contenu </span>
                                        )}

                                        {(this.props.reporting.kind === "article" || this.props.reporting.kind === "topic" || this.props.reporting.kind === "status" || this.props.reporting.kind === "comment" || this.props.reporting.kind === "topicComment") && this.state.toogleSubject && (
                                            <DraftContentReader contentRaw={this.props.reporting.content.contentRaw} />
                                        )}
                                        {this.props.reporting.kind === "album" && this.state.toogleSubject && (
                                            this.props.reporting.content.description
                                        )}
                                        {(this.props.reporting.kind === "roomMessage" || this.props.reporting.kind === "media" ) && this.state.toogleSubject && (
                                            this.props.reporting.content.content
                                        )}
                                    </Fragment>
                                ) : (<div className={"text-danger mt-16"}>Contenu Effacer</div>)}

                            </div>
                    </div>
                </div>
                <ReportingComments match={this.props.match} reportId={this.props.reporting._id} />
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        reportingInitialized: state.reporting.initialized,
        reporting: state.reporting.data,
        reportingLoading: state.reporting.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchReporting,
    resetReporting,
    updateReporting
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Reporting);
